import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { LocaleProvider } from '../context/localeContext';
import Layout from '../components/Layout';
import BlogPost from './BlogPost';
import SEO from '../components/SEO';

const BlogPostTemplate = ({ data, pageContext, location }) => {
  return (
    <LocaleProvider locale={pageContext.locale}>
      <Layout>
        <BlogPost
          title={data.blogPost.frontmatter.title}
          date={data.blogPost.frontmatter.date}
          heroImage={data.blogPost.frontmatter.image}
          content={data.blogPost.htmlAst}
          tags={data.blogPost.frontmatter.tags}
        />
      </Layout>
      <SEO
        title={data.blogPost.frontmatter.title}
        description={data.blogPost.frontmatter.overview}
        image={data.blogPost.frontmatter.image}
        type="blog"
        path={location.pathname}
        date={data.blogPost.frontmatter.date}
      />
    </LocaleProvider>
  );
};

BlogPostTemplate.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default BlogPostTemplate;

// TODO: get tags in this query
export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    blogPost: markdownRemark(id: { eq: $id }) {
      id
      htmlAst
      frontmatter {
        date
        image {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              placeholder: BLURRED
              layout: FULL_WIDTH
            )
          }
        }
        title
        overview
      }
    }
  }
`;
